import React, { Component } from 'react'
import onlyLoggedIn from './onlyLoggedIn'
import CircularProgress from '@material-ui/core/CircularProgress'
import LinearProgress from '@material-ui/core/LinearProgress'
import Icon from 'react-icons-kit'
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import axios from 'axios'


import './VideoStatus.css'

class VideoStatus extends Component {
	state = {
		status: 'processing',
		percentage: 0,
	}

	componentDidMount() {
		this.subscribe()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.short_code != this.props.match.params.short_code) {
			this.subscribe()
		}
	}

	subscribe = () => {
		let { short_code } = this.props.match.params
		let source = new EventSource(`/stream/${short_code}`)
		source.onmessage = e => {
			console.log(e)
			this.setState({ ...JSON.parse(e.data) })
		}
		axios.get(`/api/get_status/${short_code}`)
			.then(r => {
				let { status } = r.data
				let percentage = status == 'complete' ? 100 : this.state.percentage
				this.setState({ status, percentage })
			})
			.catch(r => this.props.history.push('/'))
	}

	render() {
		let { status, percentage } = this.state
		let { short_code } = this.props.match.params
		let { username } = this.props

		return (
			<div className={'video_status card'}>
				{status == 'complete' ? <Icon size={50} icon={ic_check_circle} className='status_complete' /> : <CircularProgress className='progress_circle' />}
				<h2 className='status'>Status: {status}</h2>
				<h4 className='percentage'>{percentage.toFixed(1)}%</h4>
				<LinearProgress variant="determinate" value={percentage} />
				{status == 'complete' && <Link to={`/u/${username}/v/${short_code}`}>
					<button className='custom_btn view_video'>View video</button>
				</Link>}
			</div>
		)
	}
}

const mapStateToProps = ({ username }) => ({ username })

export default onlyLoggedIn(connect(mapStateToProps)(VideoStatus))
